// pages/Connector/Connectors.js
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Divider,
  Paper,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Typography,
  Button,
  Box,
  Avatar,
  useTheme,
} from "@mui/material";
// MUI icons
import { Google, MailOutline, Sms, Group, SupportAgent, AccessTime } from "@mui/icons-material";

export default function Connectors() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { chatbotId: paramsChatbotId } = useParams();
  useEffect(() => {
    document.title = "Connectors | KlonIT Web Application";
  }, []);

  const connectors = [
    {
      title: "Google Drive",
      description: "Sync your data from Google Drive and connect with chatbot.",
      icon: <Google sx={{ fontSize: 60, color: "#34A853" }} />,
      link: `/chatbot/${paramsChatbotId}/connectors/gdrive`,
    },
    {
      title: "One Drive",
      description: "Sync your data from One Drive and connect with chatbot.",
      icon: <MailOutline sx={{ fontSize: 60, color: "#0078D4" }} />,
      link: `/chatbot/${paramsChatbotId}/connectors/onedrive`,
    },
    {
      title: "Salesforce",
      description: "Manage Salesforce leads directly from your dashboard.",
      icon: <Group sx={{ fontSize: 60, color: theme.palette.warning.main }} />,
      link: `/chatbot/${paramsChatbotId}/connectors/salesforce`,
    },
    {
      title: "Instagram",
      description:
        "Analyze post comments and train your chatbot with social insights.",
      icon: <Group sx={{ fontSize: 60, color: "#E1306C" }} />,
      link: `/chatbot/${paramsChatbotId}/connectors/instagram`,
    },
    {
      title: "Twitter/X",
      description:
        "Analyze post comments and train your chatbot with social insights.",
      icon: <Group sx={{ fontSize: 60, color: "#16147cff" }} />,
      link: `/chatbot/${paramsChatbotId}/connectors/twitter`,
    },
    {
      title: "ServiceNow",
      description:
        "Integrate with ServiceNow to manage incidents, requests, and knowledge data seamlessly.",
      icon: <SupportAgent sx={{ fontSize: 60, color: "#00ADEF" }} />, // you can change icon
      link: `/chatbot/${paramsChatbotId}/connectors/servicenow`,
    },   {
      title: "LMS",
      description: "Learning Management System - Manage courses and students.",
      icon: <SupportAgent sx={{ fontSize: 60, color: "#00ADEF" }} />,
      link: `/chatbot/${paramsChatbotId}/connectors/lms`,
    },
    {
      title: "Prayer Timing",
      description:
        "Manage Islamic prayer times calendar and train your chatbot with prayer schedules.",
      icon: <AccessTime sx={{ fontSize: 60, color: "#1B5E20" }} />,
      link: `/chatbot/${paramsChatbotId}/connectors/prayer-timing`,
    },
  ];

  return (
    <Paper
      sx={{
        p: 3,
        mt: 10,
        mx: "auto",
        maxWidth: "1200px",
        bgcolor: "background.paper",
      }}
    >
      <Box display="flex" alignItems="center" mb={3}>
        <Typography variant="h4" fontWeight="bold" color="textPrimary">
          Connectors
        </Typography>
      </Box>

      <Divider sx={{ mb: 3 }} />

      <Grid container spacing={3}>
        {connectors.map((connector, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index} display="flex">
            <Card
              sx={{
                textAlign: "center",
                borderRadius: 3,
                boxShadow: 3,
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
                "&:hover": {
                  boxShadow: 6,
                  transform: "translateY(-5px)",
                },
                transition: "0.3s",
              }}
            >
              <Box>
                <CardHeader
                  avatar={
                    <Avatar
                      sx={{
                        bgcolor: "transparent",
                        width: 80,
                        height: 80,
                        margin: "0 auto",
                      }}
                    >
                      {connector.icon}
                    </Avatar>
                  }
                />
                <CardContent>
                  <Typography variant="h6" gutterBottom color="textPrimary">
                    {connector.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 2, minHeight: 60 }}
                  >
                    {connector.description}
                  </Typography>
                </CardContent>
              </Box>
              <Box pb={2}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => navigate(connector.link)}
                >
                  Configure
                </Button>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
}
